export const debounce = (func, delay) => {
  let timeoutId;

  return function (...args) {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

export const groupBy = (array, key) => {
  return array.reduce((accumulator, item) => {
    const groupKey = typeof key === "function" ? key(item) : item[key];

    if (!accumulator[groupKey]) {
      accumulator[groupKey] = [];
    }

    accumulator[groupKey].push(item);

    return accumulator;
  }, {});
};
